import gql from 'graphql-tag';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ProveedorService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    getProveedorConDeuda(rutEmpresa, rutProveedor, nombreProveedor, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerSegunFiltroSoloProveedorDeudas(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut
                    nombre
                    codigo_direccion
                    direccion_completa
                    empresa_rut
                    fecha_registro
                    lista_precio_codigo
                    descuento_maximo
                    giro
                    telefono_principal
                    afecto_reglas_comerciales
                  }
                }
              }
            }
          }
        `,
            variables: {
                entidad: {
                    bloqueado: false,
                    empresa_rut: rutEmpresa,
                    es_cliente: true,
                    nombre: nombreProveedor,
                    rut: rutProveedor,
                },
                cantidadRegistrosPorPagina: 10,
                paginaActual: 1,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            let { mensajes, respuesta } = _.cloneDeep(response.data.cliente_proveedor.obtenerSegunFiltroSoloProveedorDeudas);
            let { registros } = respuesta;
            if (respuesta && respuesta.registros) {
                registros = _.orderBy(registros, ['nombre', 'fecha_registro'], ['asc', 'desc']);
            }
            callback({ mensajes, respuesta });
        });
    }
    getObtenerDeudaProveedor(rutEmpresa, sucursalEmpresa, rutProveedor, paginaActual, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: saldo_documentoInputType, $paginaActual: Int) {
            saldo_documento {
              obtenerSaldoDocumentoProveedor(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: 50) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    sucursal_codigo
                    cliente_proveedor_rut
                    fecha_emision
                    fechaVencimientoDocto
                    vendedor_codigo
                    vendedor_nombre
                    recorrido_codigo
                    recorrido_estado
                    protesto_cheque_codigo
                    reversa_pago_codigo
                    tipo_pago
                    ref_doc
                    pagado
                    monto
                    saldo
                    pago
                    deuda
                    seleccion
                    total_abono
                    abono
                  }
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                }
              }
            }
          }
        `,
            variables: {
                entidad: {
                    rut_emisor: rutEmpresa,
                    sucursal_codigo: sucursalEmpresa,
                    cliente_proveedor_rut: rutProveedor,
                    pagado: false,
                },
                paginaActual: paginaActual,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            let { mensajes, respuesta } = _.cloneDeep(response.data.saldo_documento.obtenerSaldoDocumentoProveedor);
            let { registros } = respuesta;
            if (respuesta && respuesta.registros) {
                registros = _.orderBy(registros, ['nombre', 'fecha_registro'], ['asc', 'desc']);
            }
            callback({ mensajes, respuesta });
        });
    }
    getObtenerDeudaProveedorTotales(entidad, callback) {
        entidad.map((docto) => {
            delete docto['__typename'];
        });
        let enti = {
            saldoDocumento: entidad,
        };
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoDTOInputType) {
            saldo_documento {
              obtenerTotalSaldoDocumentoProveedor(entidad: $entidad) {
                respuesta {
                  total_monto
                  total_pago
                  total_abono
                  total_deuda
                }
              }
            }
          }
        `,
            variables: {
                entidad: enti,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            let { mensajes, respuesta } = _.cloneDeep(response.data.saldo_documento.obtenerTotalSaldoDocumentoProveedor);
            let { registros } = respuesta;
            callback({ mensajes, respuesta });
        });
    }
    getObtenerDocumentosCanjeTotales(entidad, callback) {
        entidad.map((docto) => {
            delete docto['__typename'];
            delete docto['fechaVencimientoDocto'];
        });
        let enti = {
            saldoDocumento: entidad,
        };
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoDTOInputType) {
            saldo_documento {
              obtenerTotalDocumentoCanjeProveedor(entidad: $entidad) {
                respuesta {
                  total_monto
                  total_pago
                  total_abono
                  total_deuda
                }
              }
            }
          }
        `,
            variables: {
                entidad: enti,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            let { mensajes, respuesta } = _.cloneDeep(response.data.saldo_documento.obtenerTotalDocumentoCanjeProveedor);
            let { registros } = respuesta;
            callback({ mensajes, respuesta });
        });
    }
    setConforme(entidad, callback) {
        let enti;
        enti = { saldoDocumento: entidad };
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoDTOInputType) {
            pago {
              conformeAbonoProveedor(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  saldoDocumento {
                    codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    monto
                    saldo
                    pagado
                    cliente_proveedor_rut
                    sucursal_codigo
                    pago
                    abono
                    deuda
                  }
                }
              }
            }
          }
        `,
            variables: {
                entidad: enti,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            let { mensajes, respuesta } = _.cloneDeep(response.data.pago.conformeAbonoProveedor);
            callback({ mensajes, respuesta });
        });
    }
    setPago(entidad, callback) {
        let enti;
        enti = entidad;
        this.gqlclient.mutate({
            mutation: gql `
          mutation ($entidad: pagoDTOInputType) {
            pago {
              guardarPagosProveedor(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  codigo
                  empresa_rut
                  sucursal_codigo
                }
              }
            }
          }
        `,
            variables: {
                entidad: enti,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            let { mensajes, respuesta } = _.cloneDeep(response.data.pago.guardarPagosProveedor);
            callback({ mensajes, respuesta });
        });
    }
    getObtenerDocumentosCanjeProveedor(rutEmisor, sucursalCodigo, rutEmpresa, paginaActual, cantidadPaginas, callback) {
        let enti = {
            rut_emisor: rutEmpresa,
            sucursal_codigo: sucursalCodigo,
            cliente_proveedor_rut: rutEmisor,
            pagado: false,
        };
        this.gqlclient.query({
            query: gql `
          query ($canje: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            saldo_documento {
              obtenerDocumentoCanjeProveedor(entidad: $canje, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    monto
                    saldo
                    pagado
                    cliente_proveedor_rut
                    sucursal_codigo
                    pago
                    abono
                    deuda
                    fecha_emision
                    fechaVencimientoDocto
                    seleccion
                    tipo_pago
                    fecha_vencimiento
                  }
                }
              }
            }
          }
        `,
            variables: {
                canje: enti,
                paginaActual: paginaActual,
                cantidadRegistrosPorPagina: cantidadPaginas,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            let { mensajes, respuesta } = _.cloneDeep(response.data.saldo_documento.obtenerDocumentoCanjeProveedor);
            callback({ mensajes, respuesta });
        });
    }
    getAddFormaPago(empresaRut, sucursalCodigo, tipoPagoCodigo, tipoCuentaBancariaCodigo, bancoCodigo, numeroCuenta, monto, numeroDoc, montoConforme, fechaPago, formaPago, canjeDocumento, callback) {
        let enti = {
            empresa_rut: empresaRut,
            sucursal_codigo: sucursalCodigo,
            tipo_pago_codigo: tipoPagoCodigo,
            tipo_cuenta_bancaria_codigo: tipoCuentaBancariaCodigo,
            banco_codigo: bancoCodigo,
            numero_cuenta: numeroCuenta,
            monto: Number(monto.toString().replace(/\./g, '')),
            numero_doc: numeroDoc,
            forma_pago: formaPago,
            canjeDocumento: canjeDocumento,
            monto_coforme: montoConforme,
            fecha_pago: fechaPago
        };
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoDTOInputType) {
            pago {
              agregarFormaPagoProveedor(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  forma_pago {
                    tipo_pago_codigo
                    empresa_rut
                    tipo_cuenta_bancaria_codigo
                    banco_codigo
                    banco_nombre
                    numero_cuenta
                    fecha_pago
                    monto
                    sucursal_codigo
                    numero_doc
                    tipo_pago_nombre
                  }
                  canjeDocumento {
                    codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    monto
                    saldo
                    pagado
                    cliente_proveedor_rut
                    sucursal_codigo
                  }
                  total_forma_pago
                  diferencial_pago
                }
              }
            }
          }
        `,
            variables: {
                entidad: enti,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            let { mensajes, respuesta } = _.cloneDeep(response.data.pago.agregarFormaPagoProveedor);
            callback({ mensajes, respuesta });
        });
    }
    getCartolaProveedor(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: movimiento_pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_pago {
              cartolaProveedor(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    pago_codigo
                    cliente_proveedor_rut
                    documento
                    fecha_registro
                    fecha_vencimiento
                    referencia_documento
                    monto
                    cargo
                    abono
                    saldo
                  }
                }
              }
              saldoFinalesProveedor(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  cargo
                  abono
                  monto
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes: mensajesDetalles, respuesta: respuestaDetalles } = response.data.movimiento_pago.cartolaProveedor;
            const { mensajes: mensajesTotales, respuesta: respuestaTotales } = response.data.movimiento_pago.saldoFinalesProveedor;
            callback({
                mensajesDetalles,
                respuestaDetalles,
                mensajesTotales,
                respuestaTotales,
            });
        });
    }
    getCartolaProveedorExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: movimiento_pagoInputType) {
            movimiento_pago {
              cartolaProveedor(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.movimiento_pago.cartolaProveedor;
            callback({ mensajes, respuesta });
        });
    }
    getObtenerDocPagadorYPorPagarProveedorResumen(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          saldo_documento {
            obtenerReporteDocPagPorPagarProveedorResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                tipo
                texto
                codigo
                contexto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_emisor
                  sucursal_codigo
                  cliente_proveedor_rut
                  razonSocialCliente
                  monto
                  abono
                  saldo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerReporteDocPagPorPagarProveedorResumen;
            callback({ mensajes, respuesta });
        });
    }
    getObtenerDocPagadorYPorPagarProveedorResumenExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          saldo_documento {
            obtenerReporteDocPagPorPagarProveedorResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                tipo
                texto
                codigo
                contexto
                __typename
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  nombreArchivoExcel
                }
              }

            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerReporteDocPagPorPagarProveedorResumen;
            callback({ mensajes, respuesta });
        });
    }
    getObtenerDocPagadorYPorPagarProveedorDetalle(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            saldo_documento {
              obtenerReporteDocPagPorPagarProveedorDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    cliente_proveedor_rut
                    razonSocialCliente
                    folio
                    documento
                    fecha_emision
                    fechaVencimientoDocto
                    monto
                    abono
                    fecha_abono
                    saldo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerReporteDocPagPorPagarProveedorDetalle;
            callback({ mensajes, respuesta });
        });
    }
    getObtenerDocPagadorYPorPagarProveedorDetalleExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          saldo_documento {
            obtenerReporteDocPagPorPagarProveedorDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                tipo
                texto
                codigo
                contexto
                __typename
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  nombreArchivoExcel
                }
              }

            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerReporteDocPagPorPagarProveedorDetalle;
            callback({ mensajes, respuesta });
        });
    }
}
ProveedorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProveedorService_Factory() { return new ProveedorService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ProveedorService, providedIn: "root" });
